import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./main/routes') },
  { path: 'meets', loadChildren: () => import('./meet/routes') },
  { path: 'athletic-sb-controller', loadChildren: () => import('./athletic-sb/routes') },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'meet-list',
  },
];

const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  enableTracing: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
